import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ua",
  "use": "ua-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"ua\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"gold\" d=\"M0 0h512v512H0z\" />\n    <path fill=\"#0057b8\" d=\"M0 0h512v256H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ua.svg
// module id = null
// module chunks = 